import { useQuery } from '@tanstack/react-query';
import invariant from 'tiny-invariant';

import { ShortUrl } from '@air/api';
import { type Board } from '@air/api/types';

const getPublicCopyrightsListKey = ({
  shortId,
  search,
  boardId,
}: {
  shortId: string | undefined;
  search: string;
  boardId: Board['id'] | undefined;
}) => ['PUBLIC_COPYRIGHTS', { shortId, search, boardId }];

export const usePublicCopyrightsList = ({
  search,
  shortId,
  boardId,
}: {
  search: string;
  shortId: string;
  boardId: Board['id'] | undefined;
}) => {
  const key = getPublicCopyrightsListKey({ shortId, search, boardId });

  return useQuery({
    queryKey: key,

    queryFn: async () => {
      invariant(shortId, 'Short ID is required');

      const data = await ShortUrl.getAssetVersionFilterLookups({
        limit: 20,
        descendantBoardId: boardId,
        shortId,
        field: 'copyright',
        search,
      });

      return data.lookups.map((lookup) => lookup.value.toString());
    },
    enabled: !!shortId,
  });
};
